import React, { Children } from 'react';
import { Link } from 'react-router-dom';
export function PrivacyPage() {
  return <div className="w-full bg-background" data-id="element-204">
      <div className="container max-w-4xl mx-auto px-4 py-16" data-id="element-205">
        <Link to="/" className="inline-flex items-center gap-2 text-[hsl(var(--brand-blue-light))] dark:text-[hsl(var(--brand-blue-dark))] hover:underline mb-8" data-id="element-206">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-207">
            <path d="m15 18-6-6 6-6" data-id="element-208" />
          </svg>
          Back to Home
        </Link>

        <div className="prose prose-slate dark:prose-invert max-w-none" data-id="element-209">
          <h1 className="text-4xl font-bold text-foreground mb-4" data-id="element-210">
            Privacy Policy — WisePilot
          </h1>

          <div className="text-sm text-muted-foreground mb-8" data-id="element-211">
            <p data-id="element-212">Last Updated: February 17, 2026</p>
            <p data-id="element-213">Effective Date: February 17, 2026</p>
          </div>

          <section className="mb-8" data-id="element-214">
            <h2 className="text-2xl font-semibold text-foreground mb-4" data-id="element-215">
              1. Introduction
            </h2>
            <p className="text-muted-foreground leading-relaxed" data-id="element-216">
              WisePilot ("we," "our," or "us") operates a content management
              platform at [your-domain] (the "Service"). This Privacy Policy
              describes how we collect, use, share, and protect your information
              when you use our Service.
            </p>
          </section>

          <section className="mb-8" data-id="element-217">
            <h2 className="text-2xl font-semibold text-foreground mb-4" data-id="element-218">
              2. Information We Collect
            </h2>

            <h3 className="text-xl font-semibold text-foreground mb-3" data-id="element-219">
              2.1 Account Information
            </h3>
            <ul className="list-disc pl-6 text-muted-foreground space-y-2 mb-6" data-id="element-220">
              <li data-id="element-221">
                Name, email address, and profile information provided during
                registration
              </li>
              <li data-id="element-222">Authentication credentials managed through Supabase Auth</li>
              <li data-id="element-223">
                Team membership and role assignments within your organization
              </li>
            </ul>

            <h3 className="text-xl font-semibold text-foreground mb-3" data-id="element-224">
              2.2 Content & Business Data
            </h3>
            <ul className="list-disc pl-6 text-muted-foreground space-y-2 mb-6" data-id="element-225">
              <li data-id="element-226">
                Brand guidelines, messaging frameworks, and content briefs you
                create
              </li>
              <li data-id="element-227">
                Generated content including blog posts, landing pages, emails,
                and social copy
              </li>
              <li data-id="element-228">
                Design profiles, image styles, and brand assets you upload
              </li>
              <li data-id="element-229">Website configuration and publishing preferences</li>
            </ul>

            <h3 className="text-xl font-semibold text-foreground mb-3" data-id="element-230">
              2.3 Data From Connected Integrations
            </h3>
            <p className="text-muted-foreground mb-4" data-id="element-231">
              When you connect third-party services, we access only the data
              necessary to provide our features:
            </p>

            <div className="overflow-x-auto mb-6" data-id="element-232">
              <table className="w-full border-collapse border border-border" data-id="element-233">
                <thead data-id="element-234">
                  <tr className="bg-muted" data-id="element-235">
                    <th className="border border-border p-3 text-left font-semibold" data-id="element-236">
                      Integration
                    </th>
                    <th className="border border-border p-3 text-left font-semibold" data-id="element-237">
                      Data Accessed
                    </th>
                    <th className="border border-border p-3 text-left font-semibold" data-id="element-238">
                      Purpose
                    </th>
                  </tr>
                </thead>
                <tbody className="text-sm" data-id="element-239">
                  <tr data-id="element-240">
                    <td className="border border-border p-3" data-id="element-241">
                      Google Analytics 4
                    </td>
                    <td className="border border-border p-3" data-id="element-242">
                      Website traffic and performance metrics (read-only)
                    </td>
                    <td className="border border-border p-3" data-id="element-243">
                      Content performance analysis and optimization
                      recommendations
                    </td>
                  </tr>
                  <tr data-id="element-244">
                    <td className="border border-border p-3" data-id="element-245">
                      Google Search Console
                    </td>
                    <td className="border border-border p-3" data-id="element-246">
                      Search queries, impressions, clicks, indexing status
                      (read-only)
                    </td>
                    <td className="border border-border p-3" data-id="element-247">
                      SEO analysis and content gap identification
                    </td>
                  </tr>
                  <tr data-id="element-248">
                    <td className="border border-border p-3" data-id="element-249">
                      Google Tag Manager
                    </td>
                    <td className="border border-border p-3" data-id="element-250">
                      Tag configurations, triggers, and variables
                    </td>
                    <td className="border border-border p-3" data-id="element-251">
                      Event tracking deployment for content attribution
                    </td>
                  </tr>
                  <tr data-id="element-252">
                    <td className="border border-border p-3" data-id="element-253">GoHighLevel</td>
                    <td className="border border-border p-3" data-id="element-254">
                      Conversations, contacts, opportunities, appointments,
                      sequences
                    </td>
                    <td className="border border-border p-3" data-id="element-255">
                      Conversation intelligence, pattern analysis, and
                      content-to-lead attribution
                    </td>
                  </tr>
                  <tr data-id="element-256">
                    <td className="border border-border p-3" data-id="element-257">WordPress</td>
                    <td className="border border-border p-3" data-id="element-258">
                      Posts, pages, media, custom fields, taxonomies
                    </td>
                    <td className="border border-border p-3" data-id="element-259">
                      Content publishing, template management, and site
                      structure analysis
                    </td>
                  </tr>
                  <tr data-id="element-260">
                    <td className="border border-border p-3" data-id="element-261">
                      Meta (Facebook)
                    </td>
                    <td className="border border-border p-3" data-id="element-262">
                      Facebook Pages list, page engagement metrics, ad account
                      identifiers (read-only)
                    </td>
                    <td className="border border-border p-3" data-id="element-263">
                      Advertising campaign alignment and audience insight
                      integration
                    </td>
                  </tr>
                  <tr data-id="element-264">
                    <td className="border border-border p-3" data-id="element-265">Fireflies.ai</td>
                    <td className="border border-border p-3" data-id="element-266">
                      Meeting transcripts, speaker segments, metadata
                    </td>
                    <td className="border border-border p-3" data-id="element-267">
                      Entity extraction and content idea generation from sales
                      conversations
                    </td>
                  </tr>
                  <tr data-id="element-268">
                    <td className="border border-border p-3" data-id="element-269">Fathom.video</td>
                    <td className="border border-border p-3" data-id="element-270">
                      Call recordings metadata, transcripts, attendee
                      information
                    </td>
                    <td className="border border-border p-3" data-id="element-271">
                      Transcript import for conversation-driven content planning
                    </td>
                  </tr>
                  <tr data-id="element-272">
                    <td className="border border-border p-3" data-id="element-273">Firecrawl</td>
                    <td className="border border-border p-3" data-id="element-274">
                      Publicly available competitor webpage content
                    </td>
                    <td className="border border-border p-3" data-id="element-275">
                      Competitive content analysis and structural benchmarking
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <h3 className="text-xl font-semibold text-foreground mb-3" data-id="element-276">
              2.4 Usage & Analytics Data
            </h3>
            <p className="text-muted-foreground mb-6" data-id="element-277">
              We use PostHog to collect product usage data including page views,
              feature interactions, and session information. This data is
              associated with your user account and scoped to your organization
              for product improvement purposes.
            </p>

            <h3 className="text-xl font-semibold text-foreground mb-3" data-id="element-278">
              2.5 Automatically Collected Data
            </h3>
            <ul className="list-disc pl-6 text-muted-foreground space-y-2" data-id="element-279">
              <li data-id="element-280">IP address, browser type, device information</li>
              <li data-id="element-281">Pages visited and features used within the Service</li>
              <li data-id="element-282">Cookies and similar tracking technologies (see Section 8)</li>
            </ul>
          </section>

          <section className="mb-8" data-id="element-283">
            <h2 className="text-2xl font-semibold text-foreground mb-4" data-id="element-284">
              3. How We Use Your Information
            </h2>
            <p className="text-muted-foreground mb-4" data-id="element-285">
              We process your information for the following purposes:
            </p>
            <ul className="list-disc pl-6 text-muted-foreground space-y-3" data-id="element-286">
              <li data-id="element-287">
                <strong data-id="element-288">Content Generation:</strong> Your briefs, brand data,
                and contextual information are sent to AI providers (OpenAI,
                Anthropic, Google Gemini) to generate content on your behalf. We
                send only the minimum context necessary for each generation
                task.
              </li>
              <li data-id="element-289">
                <strong data-id="element-290">Publishing:</strong> Generated content is transmitted to
                your connected WordPress/Elementor sites at your direction.
              </li>
              <li data-id="element-291">
                <strong data-id="element-292">Analytics & Optimization:</strong> Connected analytics
                data (GA4, Search Console) is used to score content performance
                and surface optimization recommendations.
              </li>
              <li data-id="element-293">
                <strong data-id="element-294">Conversation Intelligence:</strong> GoHighLevel
                conversation data is analyzed to identify messaging patterns,
                booking correlations, and content opportunities.
              </li>
              <li data-id="element-295">
                <strong data-id="element-296">Transcript Processing:</strong> Meeting transcripts from
                Fireflies.ai or Fathom.video are processed to extract entities,
                topics, and insights for content planning.
              </li>
              <li data-id="element-297">
                <strong data-id="element-298">Email Notifications:</strong> We use Resend to deliver
                weekly performance digests and optimization reports to opted-in
                team members.
              </li>
              <li data-id="element-299">
                <strong data-id="element-300">Product Improvement:</strong> Aggregated, anonymized
                usage analytics inform product development decisions.
              </li>
            </ul>
          </section>

          <section className="mb-8" data-id="element-301">
            <h2 className="text-2xl font-semibold text-foreground mb-4" data-id="element-302">
              4. Meta Platform Data
            </h2>

            <h3 className="text-xl font-semibold text-foreground mb-3" data-id="element-303">
              4.1 Facebook Login
            </h3>
            <p className="text-muted-foreground mb-6" data-id="element-304">
              When you authenticate with Facebook Login, we receive your public
              profile information and email address. We use this solely for
              account authentication and identification within the Service.
            </p>

            <h3 className="text-xl font-semibold text-foreground mb-3" data-id="element-305">
              4.2 Meta Ads Manager
            </h3>
            <p className="text-muted-foreground mb-6" data-id="element-306">
              When you connect your Meta Ads account, we access ad account
              identifiers and campaign data in read-only mode. This data is used
              exclusively to align your content strategy with advertising
              campaigns. We do not modify, create, or manage ads on your behalf
              through this integration.
            </p>

            <h3 className="text-xl font-semibold text-foreground mb-3" data-id="element-307">
              4.3 Facebook Pages
            </h3>
            <p className="text-muted-foreground mb-6" data-id="element-308">
              We access your Facebook Pages list and page engagement metrics
              (read-only) to provide audience insights that inform content
              recommendations.
            </p>

            <h3 className="text-xl font-semibold text-foreground mb-3" data-id="element-309">
              4.4 Meta Data Use Restrictions
            </h3>
            <p className="text-muted-foreground mb-4" data-id="element-310">
              We comply with Meta Platform Terms and Policies. Specifically:
            </p>
            <ul className="list-disc pl-6 text-muted-foreground space-y-2 mb-6" data-id="element-311">
              <li data-id="element-312">
                We do not sell, license, or otherwise transfer Meta Platform
                Data to any third party
              </li>
              <li data-id="element-313">
                We do not use Meta Platform Data for surveillance or to build
                user profiles unrelated to our Service
              </li>
              <li data-id="element-314">
                We do not use Meta Platform Data to discriminate against any
                individual or group
              </li>
              <li data-id="element-315">
                Meta Platform Data is stored with the same security controls as
                all other user data (see Section 7)
              </li>
              <li data-id="element-316">
                Upon disconnection of your Meta account, we delete all
                associated Meta Platform Data within 30 days
              </li>
            </ul>

            <h3 className="text-xl font-semibold text-foreground mb-3" data-id="element-317">
              4.5 Data Deletion Requests
            </h3>
            <p className="text-muted-foreground" data-id="element-318">
              We support Meta's data deletion callback. When a user requests
              data deletion through Facebook, we receive a signed request and
              delete all associated Meta Platform Data. You may also request
              deletion directly by contacting us at support@wgmtx.com. A
              confirmation receipt with a status URL is provided for all
              deletion requests.
            </p>
          </section>

          <section className="mb-8" data-id="element-319">
            <h2 className="text-2xl font-semibold text-foreground mb-4" data-id="element-320">
              5. AI Processing & Subprocessors
            </h2>

            <h3 className="text-xl font-semibold text-foreground mb-3" data-id="element-321">
              5.1 AI Service Providers
            </h3>
            <p className="text-muted-foreground mb-4" data-id="element-322">
              Content generation requests are processed by the following AI
              providers:
            </p>

            <div className="space-y-4 mb-6" data-id="element-323">
              <div className="bg-card border border-border rounded-lg p-4" data-id="element-324">
                <p className="font-semibold text-foreground" data-id="element-325">
                  Provider: OpenAI
                </p>
                <p className="text-sm text-muted-foreground" data-id="element-326">
                  Data Sent: Content prompts, briefs, reference text, uploaded
                  images
                </p>
                <p className="text-sm text-muted-foreground" data-id="element-327">
                  Purpose: Text generation, image generation, and image analysis
                </p>
              </div>

              <div className="bg-card border border-border rounded-lg p-4" data-id="element-328">
                <p className="font-semibold text-foreground" data-id="element-329">
                  Provider: Anthropic
                </p>
                <p className="text-sm text-muted-foreground" data-id="element-330">
                  Data Sent: Content prompts, briefs, reference text
                </p>
                <p className="text-sm text-muted-foreground" data-id="element-331">
                  Purpose: Long-form copywriting and content evaluation
                </p>
              </div>

              <div className="bg-card border border-border rounded-lg p-4" data-id="element-332">
                <p className="font-semibold text-foreground" data-id="element-333">
                  Provider: Google (Gemini)
                </p>
                <p className="text-sm text-muted-foreground" data-id="element-334">
                  Data Sent: Content prompts, briefs, reference text
                </p>
                <p className="text-sm text-muted-foreground" data-id="element-335">
                  Purpose: Alternative content generation
                </p>
              </div>
            </div>

            <p className="text-muted-foreground mb-6" data-id="element-336">
              We do not send your personal account information to AI providers.
              Content prompts contain only the business context and creative
              direction necessary for generation. AI providers process data
              according to their respective data processing agreements and do
              not use your inputs to train their models under our API
              agreements.
            </p>

            <h3 className="text-xl font-semibold text-foreground mb-3" data-id="element-337">
              5.2 Infrastructure Subprocessors
            </h3>
            <div className="overflow-x-auto" data-id="element-338">
              <table className="w-full border-collapse border border-border" data-id="element-339">
                <thead data-id="element-340">
                  <tr className="bg-muted" data-id="element-341">
                    <th className="border border-border p-3 text-left font-semibold" data-id="element-342">
                      Subprocessor
                    </th>
                    <th className="border border-border p-3 text-left font-semibold" data-id="element-343">
                      Role
                    </th>
                    <th className="border border-border p-3 text-left font-semibold" data-id="element-344">
                      Data Processed
                    </th>
                  </tr>
                </thead>
                <tbody className="text-sm" data-id="element-345">
                  <tr data-id="element-346">
                    <td className="border border-border p-3" data-id="element-347">Supabase</td>
                    <td className="border border-border p-3" data-id="element-348">
                      Database & authentication
                    </td>
                    <td className="border border-border p-3" data-id="element-349">
                      All application data, encrypted at rest
                    </td>
                  </tr>
                  <tr data-id="element-350">
                    <td className="border border-border p-3" data-id="element-351">Vercel</td>
                    <td className="border border-border p-3" data-id="element-352">
                      Application hosting
                    </td>
                    <td className="border border-border p-3" data-id="element-353">
                      Request/response data, environment configuration
                    </td>
                  </tr>
                  <tr data-id="element-354">
                    <td className="border border-border p-3" data-id="element-355">Resend</td>
                    <td className="border border-border p-3" data-id="element-356">
                      Transactional email
                    </td>
                    <td className="border border-border p-3" data-id="element-357">
                      Email addresses, report content
                    </td>
                  </tr>
                  <tr data-id="element-358">
                    <td className="border border-border p-3" data-id="element-359">PostHog</td>
                    <td className="border border-border p-3" data-id="element-360">
                      Product analytics
                    </td>
                    <td className="border border-border p-3" data-id="element-361">
                      Usage events, session data
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section className="mb-8" data-id="element-362">
            <h2 className="text-2xl font-semibold text-foreground mb-4" data-id="element-363">
              6. Data Sharing
            </h2>
            <p className="text-muted-foreground mb-4" data-id="element-364">
              We do not sell your personal information. We share data only in
              these circumstances:
            </p>
            <ul className="list-disc pl-6 text-muted-foreground space-y-2" data-id="element-365">
              <li data-id="element-366">
                With your connected services — at your explicit direction (e.g.,
                publishing to WordPress, syncing with GoHighLevel)
              </li>
              <li data-id="element-367">
                With AI subprocessors — to fulfill content generation requests
                (see Section 5.1)
              </li>
              <li data-id="element-368">
                With infrastructure providers — to operate the Service (see
                Section 5.2)
              </li>
              <li data-id="element-369">
                For legal compliance — when required by law, legal process, or
                governmental request
              </li>
              <li data-id="element-370">
                Business transfers — in connection with a merger, acquisition,
                or asset sale, with prior notice
              </li>
            </ul>
          </section>

          <section className="mb-8" data-id="element-371">
            <h2 className="text-2xl font-semibold text-foreground mb-4" data-id="element-372">
              7. Data Security & Multi-Tenancy
            </h2>
            <ul className="list-disc pl-6 text-muted-foreground space-y-2" data-id="element-373">
              <li data-id="element-374">
                All data is isolated per organization ("website") using Supabase
                Row-Level Security (RLS). No organization can access another's
                data.
              </li>
              <li data-id="element-375">
                OAuth tokens for connected services (Google, Meta, GoHighLevel)
                are stored encrypted in our database with access restricted to
                authenticated, authorized users within your organization.
              </li>
              <li data-id="element-376">All data is transmitted over HTTPS/TLS.</li>
              <li data-id="element-377">
                We conduct regular security reviews of our authentication and
                authorization systems.
              </li>
              <li data-id="element-378">
                API keys and secrets are stored in environment variables, never
                in client-side code.
              </li>
            </ul>
          </section>

          <section className="mb-8" data-id="element-379">
            <h2 className="text-2xl font-semibold text-foreground mb-4" data-id="element-380">
              8. Cookies & Tracking
            </h2>
            <p className="text-muted-foreground mb-4" data-id="element-381">
              We use the following cookies and tracking technologies:
            </p>
            <ul className="list-disc pl-6 text-muted-foreground space-y-2" data-id="element-382">
              <li data-id="element-383">
                Essential cookies — Supabase authentication session tokens
                (required for the Service to function)
              </li>
              <li data-id="element-384">
                Analytics cookies — PostHog analytics for product usage
                measurement (can be opted out)
              </li>
              <li data-id="element-385">
                No third-party advertising cookies — We do not serve ads within
                the Service
              </li>
            </ul>
          </section>

          <section className="mb-8" data-id="element-386">
            <h2 className="text-2xl font-semibold text-foreground mb-4" data-id="element-387">
              9. Data Retention
            </h2>
            <ul className="list-disc pl-6 text-muted-foreground space-y-2" data-id="element-388">
              <li data-id="element-389">
                Account data is retained for the duration of your account and
                deleted within 90 days of account closure.
              </li>
              <li data-id="element-390">
                Generated content is retained until you delete it or close your
                account.
              </li>
              <li data-id="element-391">
                Connected integration data (analytics snapshots, conversation
                data, transcripts) is retained while the integration is active
                and deleted within 30 days of disconnection.
              </li>
              <li data-id="element-392">
                Meta Platform Data is deleted within 30 days of account
                disconnection or upon receiving a valid deletion request.
              </li>
              <li data-id="element-393">
                Usage analytics are retained in aggregated, anonymized form
                indefinitely for product improvement.
              </li>
            </ul>
          </section>

          <section className="mb-8" data-id="element-394">
            <h2 className="text-2xl font-semibold text-foreground mb-4" data-id="element-395">
              10. Your Rights
            </h2>
            <p className="text-muted-foreground mb-4" data-id="element-396">
              Depending on your jurisdiction, you may have the right to:
            </p>
            <ul className="list-disc pl-6 text-muted-foreground space-y-2 mb-4" data-id="element-397">
              <li data-id="element-398">Access your personal data</li>
              <li data-id="element-399">Correct inaccurate data</li>
              <li data-id="element-400">Delete your data ("right to be forgotten")</li>
              <li data-id="element-401">Export your data in a portable format</li>
              <li data-id="element-402">Withdraw consent for optional data processing</li>
              <li data-id="element-403">Object to processing based on legitimate interests</li>
              <li data-id="element-404">Restrict processing of your data</li>
              <li data-id="element-405">
                Disconnect any third-party integration at any time, triggering
                deletion of that integration's data
              </li>
            </ul>
            <p className="text-muted-foreground" data-id="element-406">
              To exercise any right, contact us at support@wgmtx.com.
            </p>
          </section>

          <section className="mb-8" data-id="element-407">
            <h2 className="text-2xl font-semibold text-foreground mb-4" data-id="element-408">
              11. International Data Transfers
            </h2>
            <p className="text-muted-foreground" data-id="element-409">
              Our Service is hosted on Vercel (US-based infrastructure). AI
              processing occurs through US-based providers (OpenAI, Anthropic,
              Google). By using the Service, you consent to the transfer of data
              to the United States. We rely on standard contractual clauses and
              provider DPAs where applicable for cross-border transfers.
            </p>
          </section>

          <section className="mb-8" data-id="element-410">
            <h2 className="text-2xl font-semibold text-foreground mb-4" data-id="element-411">
              12. Children's Privacy
            </h2>
            <p className="text-muted-foreground" data-id="element-412">
              The Service is not directed to individuals under 16. We do not
              knowingly collect personal information from children.
            </p>
          </section>

          <section className="mb-8" data-id="element-413">
            <h2 className="text-2xl font-semibold text-foreground mb-4" data-id="element-414">
              13. Changes to This Policy
            </h2>
            <p className="text-muted-foreground" data-id="element-415">
              We may update this Privacy Policy from time to time. We will
              notify you of material changes by email or through the Service at
              least 30 days before they take effect.
            </p>
          </section>

          <section className="mb-8" data-id="element-416">
            <h2 className="text-2xl font-semibold text-foreground mb-4" data-id="element-417">
              14. Contact
            </h2>
            <p className="text-muted-foreground mb-2" data-id="element-418">
              For privacy inquiries, data requests, or complaints:
            </p>
            <div className="text-muted-foreground" data-id="element-419">
              <p className="font-semibold" data-id="element-420">Wise Growth Marketing LLC</p>
              <p data-id="element-421">Email: support@wgmtx.com</p>
              <p data-id="element-422">Address: 1401 Lake Plaza Dr, 200-152, Spring, TX 77389</p>
            </div>
          </section>
        </div>
      </div>
    </div>;
}